import styled from "styled-components";
import { rgba } from "polished";
const RadioWrapper = styled("label")(
  {
    alignItems: "flex-start",
    display: "flex",
    margin: 0,
    padding: 0
  },
  ({ disabled }) => disabled ? {
    color: "rgba(0, 0, 0, 0.25)"
  } : {
    cursor: "pointer"
  }
);
const RadioDisplay = styled("span")(
  ({ theme }) => ({
    alignItems: "center",
    backgroundColor: "#ffffff",
    borderCollapse: "separate",
    borderColor: theme.controlBorderColor,
    borderRadius: "50%",
    borderStyle: "solid",
    borderWidth: 1,
    boxSizing: "border-box",
    display: "flex",
    flex: "0 0 auto",
    height: 16,
    justifyContent: "center",
    margin: "2px 0",
    position: "relative",
    transition: "all 0.3s",
    width: 16,
    "&::after": {
      backgroundColor: theme.color.blue6,
      borderRadius: "50%",
      content: JSON.stringify(""),
      height: 8,
      opacity: 0,
      transform: "scale(0)",
      transition: "all 0.3s",
      width: 8
    },
    [`${RadioWrapper}:active &&`]: {
      boxShadow: `0 0 0 2px ${rgba(theme.color.blue6, 0.25)}`
    },
    [`${RadioWrapper}:hover &&`]: {
      borderColor: theme.color.blue6
    },
    "&:focus-within": {
      boxShadow: "0 0 0 2px rgba(0, 0, 0, 0.05)"
    }
  }),
  ({ checked, theme }) => checked ? {
    borderColor: theme.color.blue6,
    "&::after": {
      opacity: 1,
      transform: "scale(1)"
    },
    [`&:focus-within`]: {
      boxShadow: `0 0 0 2px ${rgba(theme.color.blue6, 0.25)}`
    }
  } : void 0,
  ({ disabled }) => disabled ? {
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    [`&, ${RadioWrapper}:hover &&`]: {
      borderColor: "rgba(0, 0, 0, 0.25)"
    },
    [`${RadioWrapper}:active &, &:focus-within`]: {
      boxShadow: "none"
    },
    "&::after": {
      backgroundColor: "rgba(0, 0, 0, 0.25)"
    }
  } : void 0
);
const RadioInput = styled("input").attrs({
  type: "radio"
})({
  boxSizing: "border-box",
  cursor: "inherit",
  left: -1,
  height: "calc(100% + 2px)",
  margin: 0,
  opacity: 0,
  position: "absolute",
  top: -1,
  width: "calc(100% + 2px)"
});
const RadioContent = styled("div")({
  flex: "1 1 0",
  paddingLeft: 8
});
const RadioTitle = styled("h5")(({ theme }) => ({
  color: theme.color.gray9,
  font: "inherit",
  fontWeight: theme.fontWeight.medium,
  margin: 0
}));
const RadioDescription = styled("p")(
  {
    margin: 0
  },
  ({ hasTitle, theme }) => hasTitle ? {
    color: theme.color.gray7
  } : void 0
);
export {
  RadioContent,
  RadioDescription,
  RadioDisplay,
  RadioInput,
  RadioTitle,
  RadioWrapper
};
